import { inmunetApi } from '../../../api';

export const getNotificaciones = async() => {

    try {

        const { data } = await inmunetApi.get(`/notificacionesAdmin`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const eliminarNotificacion = async({ id }) => {

    try {

        const { data } = await inmunetApi.delete(`/notificacionesAdmin/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al eliminar notificación';

        return id;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al eliminar notificación');
        }

    }

};

export const eliminarNotificaciones = async() => {

    try {

        const { data } = await inmunetApi.delete(`/notificacionesAdmin`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al eliminar notificaciones';

        return true;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al eliminar notificaciones');
        }

    }

};